import { useCallback, useRef } from 'react';
import { CompanyMeasurementDatesService } from 'api';

interface UseToggleMeasurementDateReadyParams {
  refreshDates: () => Promise<void>;
}

const useToggleMeasurementDateReady = ({ refreshDates }: UseToggleMeasurementDateReadyParams) => {
  const isTogglingRef = useRef(false);

  const handleToggleReady = useCallback(
    async (cmdId: number, currentIsReady: boolean, event?: React.MouseEvent) => {
      event?.stopPropagation();
      if (isTogglingRef.current) return;
      isTogglingRef.current = true;
      try {
        await CompanyMeasurementDatesService.apiCompanyMeasurementDatesToggleReadyPartialUpdate(cmdId, {
          is_ready: !currentIsReady,
        });
        await refreshDates();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to toggle measurement date readiness:', error);
      } finally {
        isTogglingRef.current = false;
      }
    },
    [refreshDates]
  );

  return { handleToggleReady };
};

export default useToggleMeasurementDateReady;
